export default __webpack_public_path__ + "static/media/iconGridUno.d0b0dbb9.png";